/* assets/js/modules/command-palette.js
   ⌘K palette with fuzzy search over Ghost Content API posts + tags + authors.
   Depends on: DOM elements rendered by partials/command-palette.hbs. */

(function () {
    'use strict';

    const API_KEY = document.querySelector('meta[name="content-api-key"]')?.content;
    const API_BASE = window.DISANE_CONTENT_API_URL || '/ghost/api/content/';
    const POSTS_URL = API_BASE + 'posts/?key=' + API_KEY + '&fields=id,title,url,feature_image,slug&limit=all';
    const SEARCH_INDEX_URL = API_BASE + 'search-index/?key=' + API_KEY;

    const root = document.querySelector('[data-cmdk-root]');
    const input = document.querySelector('[data-cmdk-input]');
    const list = document.querySelector('[data-cmdk-list]');
    const count = document.querySelector('[data-cmdk-count]');
    if (!root || !input || !list) return;

    let index = { posts: [], tags: [], authors: [] };
    let active = 0;
    let current = [];

    async function loadIndex() {
        if (index.posts.length) return;
        try {
            if (API_KEY) {
                // Posts via content API (includes feature_image), tags/authors via search-index
                const [pRes, sRes] = await Promise.all([
                    fetch(POSTS_URL),
                    fetch(SEARCH_INDEX_URL),
                ]);
                if (pRes.ok) {
                    const j = await pRes.json();
                    index.posts = (j.posts || []).map(p => ({
                        id: p.id, title: p.title, url: p.url, slug: p.slug,
                        feature_image: p.feature_image,
                    }));
                }
                if (sRes.ok) {
                    const j = await sRes.json();
                    index.tags = j.tags || [];
                    index.authors = j.authors || [];
                }
                if (index.posts.length) return;
            }
            // Fallback: scrape posts from sitemap (no images)
            const r = await fetch('/sitemap-posts.xml');
            const text = await r.text();
            index.posts = [...text.matchAll(/<loc>([^<]+)<\/loc>/g)].slice(0, 200).map(m => ({
                title: decodeURIComponent(m[1].split('/').filter(Boolean).pop() || '').replace(/-/g, ' '),
                url: m[1], feature_image: null,
            }));
        } catch (e) { console.warn('cmdk: index load failed', e); }
    }

    // Tiny fuzzy scorer
    function score(q, s) {
        q = q.toLowerCase(); s = (s || '').toLowerCase();
        if (!q) return 0;
        if (s.includes(q)) return 100 - s.indexOf(q);
        let qi = 0, hits = 0;
        for (let i = 0; i < s.length && qi < q.length; i++) {
            if (s[i] === q[qi]) { qi++; hits++; }
        }
        return qi === q.length ? hits : 0;
    }

    function postItem(p, s) { return { kind: 'post', label: p.title, url: p.url, image: p.feature_image || null, s }; }
    function tagItem(t, s)  { return { kind: 'tag',  label: '#' + (t.name || t.slug), url: t.url || ('/tag/' + t.slug), s }; }
    function authItem(a, s) { return { kind: 'author', label: a.name || a.slug, url: a.url || ('/author/' + a.slug), s }; }

    function search(q) {
        if (!q) {
            return [
                ...index.posts.slice(0, 6).map(p => postItem(p, 0)),
                ...index.tags.slice(0, 3).map(t => tagItem(t, 0)),
            ];
        }
        const out = [];
        for (const p of index.posts) { const s = score(q, p.title); if (s > 0) out.push(postItem(p, s)); }
        for (const t of index.tags)  { const s = score(q, t.name || t.slug); if (s > 0) out.push(tagItem(t, s)); }
        for (const a of index.authors){ const s = score(q, a.name || a.slug); if (s > 0) out.push(authItem(a, s)); }
        return out.sort((a, b) => b.s - a.s).slice(0, 20);
    }

    function buildThumb(it) {
        if (it.kind === 'post' && it.image) {
            const img = document.createElement('img');
            img.className = 'thumb';
            img.src = it.image;
            img.alt = '';
            img.loading = 'lazy';
            return img;
        }
        const span = document.createElement('span');
        span.className = 'thumb thumb--glyph';
        span.setAttribute('aria-hidden', 'true');
        span.textContent = it.kind === 'tag' ? '#' : (it.kind === 'author' ? '@' : '◆');
        return span;
    }
    function render() {
        list.textContent = '';
        if (!current.length) {
            const empty = document.createElement('div');
            empty.className = 'd-cmdk-item';
            empty.style.color = 'var(--color-text-dim)';
            const lbl = document.createElement('span'); lbl.className = 'label'; lbl.textContent = 'no matches';
            empty.appendChild(lbl); list.appendChild(empty);
        } else {
            current.forEach((it, i) => {
                const a = document.createElement('a');
                a.className = 'd-cmdk-item';
                a.dataset.idx = String(i);
                a.href = it.url;
                a.setAttribute('aria-selected', String(i === active));
                a.appendChild(buildThumb(it));
                const label = document.createElement('span');
                label.className = 'label'; label.textContent = it.label;
                a.appendChild(label);
                list.appendChild(a);
            });
        }
        count.textContent = current.length + ' results';
    }
    function escapeHTML(s) { return String(s).replace(/[&<>"']/g, c => ({ '&': '&amp;', '<': '&lt;', '>': '&gt;', '"': '&quot;', "'": '&#39;' }[c])); }

    function open() {
        root.classList.add('open'); root.setAttribute('aria-hidden', 'false');
        loadIndex().then(() => { current = search(input.value); render(); });
        requestAnimationFrame(() => input.focus());
    }
    function close() { root.classList.remove('open'); root.setAttribute('aria-hidden', 'true'); }

    // Keyboard
    document.addEventListener('keydown', (e) => {
        if ((e.key === 'k' || e.key === 'K') && (e.metaKey || e.ctrlKey)) { e.preventDefault(); root.classList.contains('open') ? close() : open(); return; }
        if (!root.classList.contains('open')) return;
        if (e.key === 'Escape') { close(); }
        if (e.key === 'ArrowDown') { e.preventDefault(); active = Math.min(active + 1, current.length - 1); render(); }
        if (e.key === 'ArrowUp') { e.preventDefault(); active = Math.max(active - 1, 0); render(); }
        if (e.key === 'Enter') { const it = current[active]; if (it) location.href = it.url; }
    });
    input.addEventListener('input', () => { current = search(input.value); active = 0; render(); });
    root.addEventListener('click', (e) => { if (e.target === root) close(); });
    document.querySelectorAll('[data-open-cmdk]').forEach(b => b.addEventListener('click', open));

    // Expose
    window.DisaneSearch = { query: async (q) => { await loadIndex(); return search(q); } };
})();
